import { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/portfolio-blog", label: "Portfolio" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
  { to: "/about-terminal", label: "Terminal" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="w-full nav-glass z-50 sticky top-0">
      <div className="max-w-5xl mx-auto flex items-center justify-between px-6 py-3.5">
        {/* Logo */}
        <NavLink to="/" className="select-none group">
          <span className="font-mono text-lg font-bold tracking-widest gradient-text-green-cyan">
            &lt;Pankaj Singh /&gt;
          </span>
        </NavLink>

        {/* Hamburger Icon */}
        <button
          className="sm:hidden flex flex-col gap-1.5 focus:outline-none p-1"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span
            className={`block h-0.5 w-6 bg-green-400 rounded-full transition-all duration-300 ${
              open ? "rotate-45 translate-y-2" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-green-400 rounded-full transition-all duration-300 ${
              open ? "opacity-0 scale-x-0" : ""
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-green-400 rounded-full transition-all duration-300 ${
              open ? "-rotate-45 -translate-y-2" : ""
            }`}
          />
        </button>

        {/* Desktop Menu */}
        <ul className="hidden sm:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `nav-link font-mono text-sm ${
                    isActive ? "nav-link-active" : ""
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
            className="sm:hidden flex flex-col items-center gap-1 pb-4 px-4 overflow-hidden border-t border-green-500/10"
          >
            {navLinks.map((link, i) => (
              <motion.li
                key={link.to}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.07 }}
                className="w-full"
              >
                <NavLink
                  to={link.to}
                  end={link.to === "/"}
                  className={({ isActive }) =>
                    `block w-full text-center py-2.5 px-4 rounded-lg font-mono text-sm transition-all duration-200 ${
                      isActive
                        ? "bg-cyan-500/10 text-slate-100 border border-cyan-500/30"
                        : "text-slate-300/80 hover:text-cyan-200 hover:bg-cyan-500/5"
                    }`
                  }
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </NavLink>
              </motion.li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
